import Icon from "@ant-design/icons"
import React from "react"

const ArrowCircleSvg = ({ rotation }: { rotation: number }) => (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" transform={`rotate(${rotation})`}>
        <circle cx="13" cy="13" r="12" fill="#F8F8F9" stroke="#DEE4EA" />
        <path d="M9 14.3328L13 10.3328L17 14.3328" stroke="#606C7E" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const RightArrowCircleSvg = () => <ArrowCircleSvg rotation={90} />

const DownArrowCircleSvg = () => <ArrowCircleSvg rotation={180} />

export const ExpandableListItemIcon = ({ expanded, ...props }: Omit<React.ComponentProps<typeof Icon>, "component"> & { expanded: boolean }) => (
    <Icon component={expanded ? DownArrowCircleSvg : RightArrowCircleSvg} {...props} />
)
